import { Typography } from '@astro-ui/components'
import UploadImg from 'assets/images/upload-img.svg'
import theme from '@astro-ui/theme'
import { StyledBoxImage } from './style'

type EmptyBoxToUploadPropsType = {
  index: number
  onClickBoxImage: (index: number) => void
}

const EmptyBoxToUpload = ({ index, onClickBoxImage }: EmptyBoxToUploadPropsType) => {
  const getImageDescriptionIfEmpty = () => (index === 0 ? 'Utama' : index + 1)

  return (
    <StyledBoxImage key={`upload-${index}`} onClick={() => onClickBoxImage(index)}>
      <img src={UploadImg} alt="UploadImg" />
      <Typography variant="body2" color={theme.palette.primary.main} marginTop="5px">
        Foto {getImageDescriptionIfEmpty()}
      </Typography>
    </StyledBoxImage>
  )
}
export default EmptyBoxToUpload
